import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, daysSince } from '../tokens';

const LapseCountdownChip = ({ nextPaymentDate, gracePeriodDays = 14, status = 'Active' }) => {
  if (!nextPaymentDate || status === 'Closed') return null;

  const daysOverdue = -daysSince(nextPaymentDate); // positive = in future
  const daysUntilLapse = daysOverdue + gracePeriodDays;

  let color, label, icon;
  if (daysUntilLapse < 0) {
    color = colors.error;
    label = `Lapsed ${Math.abs(daysUntilLapse)} days ago`;
    icon = 'error';
  } else if (daysOverdue < 0) {
    // Overdue but in grace period
    color = colors.error;
    label = `Lapses in ${daysUntilLapse} days if unpaid`;
    icon = 'warning';
  } else if (daysOverdue < 3) {
    color = colors.warning;
    label = `Due in ${daysOverdue} day${daysOverdue === 1 ? '' : 's'}`;
    icon = 'clock';
  } else {
    color = colors.success;
    label = `Next: ${new Date(nextPaymentDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
    icon = 'success';
  }

  return (
    <span
      title={`Next payment ${new Date(nextPaymentDate).toLocaleDateString()}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: space[1],
        padding: `4px 10px`,
        background: `${color}14`,
        color,
        border: `1px solid ${color}`,
        borderRadius: radius.pill,
        ...type.small,
        fontWeight: 700,
      }}
    >
      <Icon category="utility" name={icon} size="xx-small" style={{ fill: color }} />
      {label}
    </span>
  );
};

export default LapseCountdownChip;
